export const getCountdown = (expiryDate) => {
    if (!expiryDate) return "--";

    const now = Date.now();
    const expiry = new Date(expiryDate).getTime();

    if (isNaN(expiry)) return "--";

    if (now >= expiry) {
        return "--";
    }

    const diff = expiry - now;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const format = (val) => String(val).padStart(2, "0");

    return `${format(hours)} : ${format(minutes)} : ${format(seconds)}`;
};
